import { render, staticRenderFns } from "./BrandRow.vue?vue&type=template&id=ce32ae4a"
import script from "./BrandRow.vue?vue&type=script&lang=js"
export * from "./BrandRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports